<div class="content">
  <ngb-carousel *ngIf="images">
    <ng-template ngbSlide *ngFor="let image of images">
      <div class="picsum-img-wrapper w-100">
        <img [src]="image" alt="Random first slide" class="d-block" />
      </div>
    </ng-template>
  </ngb-carousel>
</div>
